import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'dateFormatPipe',
    standalone: false
})
export class DateFormatPipe implements PipeTransform {
    transform(value: string) {
       var datePipe = new DatePipe("en-US");
        value = datePipe.transform(value, 'MMM-dd-yyyy');
        return value;
    }
    transformDate(value: string) {
        var datePipe = new DatePipe("en-US");
        value = datePipe.transform(value, 'yyyy-MM-ddTHH:mm:ss.SSS');
        return value;
    }
}